import { c as _c } from "react/compiler-runtime";
import Button from '@helios/Button';
import FormActions from '@helios/FormActions';
import Spinner from '@helios/Spinner';
function ApplicationFormStep(t0) {
  const $ = _c(8);
  const {
    children,
    isSubmitting
  } = t0;
  let t1;
  if ($[0] !== isSubmitting) {
    t1 = isSubmitting ? <Spinner label="Submitting" /> : "Next";
    $[0] = isSubmitting;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isSubmitting || $[3] !== t1) {
    t2 = <FormActions><Button type="submit" shape="rounded" fullWidth={true} disabled={isSubmitting}>{t1}</Button></FormActions>;
    $[2] = isSubmitting;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t2) {
    t3 = <>{children}{t2}</>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export default ApplicationFormStep;